interface fnCallable {
	storeAuth_v2: string;
	refreshToken_v2: string;
	submitFile_v2: string;
	getFileStatus_v2: string;
	getProfileId_v2: string;
	getProfileIds_v2: string;
	setProfileId_v2: string;
	setProfileIds_v2: string;
	connected_v2: string;
	getToken_v2: string;
	getDocument_v2: string;
}

export const fnCallable: fnCallable = {
	storeAuth_v2: 'stewart_storeAuth_v2',
	refreshToken_v2: 'stewart_refreshToken_v2',
	submitFile_v2: 'stewart_submitFile_v2',
	getFileStatus_v2: 'stewart_getFileStatus_v2',
	getProfileId_v2: 'stewart_getProfileId_v2',
	getProfileIds_v2: 'stewart_getProfileIds_v2',
	setProfileId_v2: 'stewart_setProfileId_v2',
	setProfileIds_v2: 'stewart_setProfileIds_v2',
	connected_v2: 'stewart_connected_v2',
	getToken_v2: 'stewart_getToken_v2',
	getDocument_v2: 'stewart_getDocument_v2',
};
